import { createApi } from '@reduxjs/toolkit/query/react';
import { getConfig } from '@/config';
import { clientKeyBaseQuery } from './clientKeyBaseQuery';
// ---------------------------------------------------------------------------
// API slice
// ---------------------------------------------------------------------------
/**
 * Dedicated RTK Query API slice for product read operations (search-product).
 *
 * This slice uses its own `fetchBaseQuery` because the Search API product
 * endpoints authenticate via `client-key` — not the Bearer-token auth that
 * `ccApi` injects via `prepareHeaders`.
 *
 * @see https://redux-toolkit.js.org/rtk-query/api/created-api/code-splitting
 */
export const searchProductApi = createApi({
    reducerPath: 'searchProductApi',
    baseQuery: clientKeyBaseQuery,
    // No tagTypes — these are read-only endpoints with no cache invalidation needed.
    endpoints: (builder) => ({
        /**
         * Fetches a product record with cache bypass (`X-Groupby-Skip-Cache`).
         * Used by the product-drawer to always show fresh data.
         */
        getProductRecord: builder.query({
            query: ({ clientKey, collectionName, productId }) => ({
                url: `${getConfig().searchApiUrl}/product?collection=${collectionName}&productId=${productId}`,
                method: 'GET',
                headers: {
                    Authorization: `client-key ${clientKey}`,
                    'X-Groupby-Skip-Cache': 'true',
                },
            }),
        }),
        /**
         * Fetches a product by ID (uses RTK Query caching, no skip-cache header).
         * Used by product-pill for hover previews.
         */
        getProductById: builder.query({
            query: ({ clientKey, collection, productId }) => ({
                url: `${getConfig().searchApiUrl}/product?collection=${collection}&productId=${productId}`,
                method: 'GET',
                headers: {
                    Authorization: `client-key ${clientKey}`,
                },
            }),
        }),
    }),
});
export const { useGetProductRecordQuery, useLazyGetProductRecordQuery, useGetProductByIdQuery, useLazyGetProductByIdQuery, } = searchProductApi;
